"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Files = exports.viewType = exports.FileList = exports.FileUpload = exports.FileAction = exports.actionType = exports.FileItem = void 0;
var react_1 = require("react");
var jsx_runtime_1 = require("react/jsx-runtime");
var react_2 = require("react");
var Icon_1 = require("./Icon");
var mouse_down_hook_1 = require("../hooks/mouse-down-hook");
var BackgroundTokens = {
    default: 'bg-alias-color-bg-base',
    hover: 'hover:bg-alias-state-base-hover',
    pressed: 'hover:bg-alias-state-base-pressed',
};
var BorderTokens = {
    default: 'border-alias-color-border-default',
    hover: 'hover:border-alias-color-border-hover',
    focus: 'focus:border-alias-color-border-hover',
    pressed: 'hover:bg-alias-state-base-pressed',
    radius: 'rounded-component-file-border-radius',
    dashed: 'border-dashed',
    solid: 'border-solid',
    width: 'border-[1px]', //border-component-file-width not working!
};
/**
 * @param {string} name file name that is displayed beside icon
 * @param {ActionProps} button first action (button or input) (optional)
 * @param {ActionProps} buttonTwo second action (button or input) (optional)
 * @param {string} link URL of the file
 * @param {string} className extra classes for wrapper div (optional)
 * @param {Array<FileProps>} otherFiles list of files uploaded alongside this file,
 * meant to be given to ActionProp, sent from FileUpload (optional)
 **/
var FileItem = function (props) {
    var name = props.name, button = props.button, buttonTwo = props.buttonTwo, link = props.link, className = props.className, otherFiles = props.otherFiles;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex items-center justify-between ".concat(className) }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "block truncate" }, { children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: "Paperclip", className: "!h-component-icon-size-lg !w-component-icon-size-lg inline text-alias-color-icon-base" }), (0, jsx_runtime_1.jsx)("a", __assign({ href: link, target: "_blank", rel: "noreferrer", className: "inline text-ellipsis pl-component-file-space-tight\n          text-alias-color-text-weak font-alias-font-label-weak" }, { children: name }))] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex pl-component-file-space-base" }, { children: [button && ((0, jsx_runtime_1.jsx)(exports.FileAction, __assign({}, button, { fileName: name, files: otherFiles }))), buttonTwo && ((0, jsx_runtime_1.jsx)("div", { className: "w-px bg-alias-color-border-base mx-2" })), buttonTwo ? ((0, jsx_runtime_1.jsx)(exports.FileAction, __assign({}, buttonTwo, { fileName: name, files: otherFiles }))) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}))] }))] })));
};
exports.FileItem = FileItem;
//--------------Action (button or input) for file----------------//
var actionType;
(function (actionType) {
    actionType["Edit"] = "edit";
    actionType["Update"] = "update";
})(actionType = exports.actionType || (exports.actionType = {}));
/**
 * @param {string} text text displayed for the action
 * @param {actionType} type type of action, either 'edit' or 'update'
 * @param {Array<FileProp>} files the other files assoicated with the FileItem
 * this action belongs to (optional)
 * @param {string} fileName the name of the file this action belongs to (optional)
 * @param {Function} eHandler function to process the action (edit or update) (optional)
 **/
var FileAction = function (props) {
    var text = props.text, type = props.type, files = props.files, fileName = props.fileName, eHandler = props.eHandler;
    if (type === actionType.Edit && eHandler) {
        return ((0, jsx_runtime_1.jsx)("button", __assign({ onClick: function () { return eHandler(fileName, files); }, className: "text-sm text-alias-color-text-link-default font-medium" }, { children: text })));
    }
    else if (type === actionType.Update && eHandler) {
        return ((0, jsx_runtime_1.jsxs)("label", __assign({ className: "\n        text-sm text-alias-color-text-link-default\n        font-medium cursor-pointer\n        ", htmlFor: "file-upload" }, { children: [(0, jsx_runtime_1.jsx)("span", { children: text }), (0, jsx_runtime_1.jsx)("input", { id: "file-upload", type: "file", name: "file-upload", className: "sr-only", onChange: function (e) {
                        if (e.target.files) {
                            eHandler(fileName, files, e.target.files[0]);
                        }
                    } })] })));
    }
    else
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
};
exports.FileAction = FileAction;
var FileUploadCoreClasses = function (inputPressed) {
    return "\n  ".concat(BorderTokens.width, "\n  ").concat(BorderTokens.dashed, "\n  ").concat(BorderTokens.radius, "\n  ").concat(BorderTokens.default, "\n  ").concat(BorderTokens.hover, "\n  ").concat(BorderTokens.focus, "\n  ").concat(inputPressed ? "".concat(BorderTokens.pressed) : '', "\n  ").concat(BackgroundTokens.hover, "\n  ").concat(inputPressed ? "".concat(BackgroundTokens.pressed) : '', "\n  flex\n  flex-col\n  items-center\n  justify-center\n  p-component-file-upload-padding\n  hover:cursor-pointer\n");
};
/**
 * @param {Array<string>} fileType the desired file formats to be uploaded
 * @param {stirng} sizeLimit the maximum size of value that should be uploaded
 * @param {Function} onUpload what to do when a file is uploaded (optional)
 * @param {boolean} initValue the initial state of the upload prompt, pressed or
 * not pressed (optional)
 * @param {boolean} multiple whether or not multiple files should be uploaded
 **/
var FileUpload = function (props) {
    var fileType = props.fileType, sizeLimit = props.sizeLimit, onUpload = props.onUpload, initValue = props.initValue, multiple = props.multiple;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var inputRef = (0, react_2.useRef)(null);
    var inputPressed = (0, mouse_down_hook_1.default)({ ref: inputRef, initValue: initValue });
    var dropHandler = function (e) {
        e.preventDefault();
        if (onUpload) {
            onUpload(e.dataTransfer.files);
        }
    };
    return ((0, jsx_runtime_1.jsx)("label", __assign({ htmlFor: "file-upload" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "".concat(FileUploadCoreClasses(inputPressed)), onDrop: dropHandler, ref: inputRef, onDragOver: function (e) { return e.preventDefault(); } }, { children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: "Download01", className: "!h-component-icon-size-xl !w-component-icon-size-xl\n          mb-component-file-upload-space-base text-alias-color-icon-base" }), (0, jsx_runtime_1.jsxs)("p", __assign({ className: "mb-component-file-upload-space-tight" }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ tabIndex: 0, role: "button", onKeyDown: function (e) {
                                if (e.key === 'Enter') {
                                    var input = document.getElementById('file-upload');
                                    input === null || input === void 0 ? void 0 : input.click();
                                }
                            }, className: "\n              font-alias-font-label-strong-font-family font-alias-font-label-strong-font-weight\n              leading-alias-font-label-stong-line-height\n              tracking-alias-font-label-strong-letter-spacing cursor-pointer text-alias-color-text-link-default\n              hover:text-alias-color-text-link-hover active:text-alias-color-text-link-pressed\n              " }, { children: "Upload a file or drag and drop" })), (0, jsx_runtime_1.jsx)("input", { id: "file-upload", type: "file", name: "file-upload", className: "sr-only", onChange: function (e) {
                                if (onUpload && e.target.files) {
                                    onUpload(e.target.files);
                                }
                            }, multiple: multiple })] })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "\n          font-alias-font-caption-font-family font-alias-font-caption-font-weight\n          font-body leading-alias-font-caption-line-height text-alias-font-caption-font-size\n          leading-alias-font-caption-line-height text-alias-color-text-weaker\n          " }, { children: "".concat(fileType === null || fileType === void 0 ? void 0 : fileType.join(', '), " up to ").concat(sizeLimit) }))] })) })));
};
exports.FileUpload = FileUpload;
var FileListCoreClasses = function () {
    return "\n  p-component-file-padding\n  ".concat(BackgroundTokens.default, "\n  ").concat(BorderTokens.solid, "\n  ").concat(BorderTokens.width, "\n  ").concat(BorderTokens.radius, "\n  ").concat(BorderTokens.default, "\n  ");
};
/**
 * @param {Array<FileProps>} files the list of files to be displayed
 **/
var FileList = function (props) {
    var files = props.files;
    if (files && files.length > 0) {
        var renderedFiles = files.map(function (file) {
            return ((0, react_1.createElement)(exports.FileItem, __assign({}, file, { otherFiles: files, key: files.indexOf(file), className: files.indexOf(file) === files.length - 1
                    ? ''
                    : 'mb-component-file-space-base' })));
        });
        return (0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat(FileListCoreClasses()) }, { children: renderedFiles }));
    }
    else
        return (0, jsx_runtime_1.jsx)("h2", __assign({ className: "".concat(FileListCoreClasses()) }, { children: "No Files" }));
};
exports.FileList = FileList;
//======================USE THIS=========================//
//--------------Files (upload <--> list)----------------//
var viewType;
(function (viewType) {
    viewType["Upload"] = "upload";
    viewType["List"] = "list";
})(viewType = exports.viewType || (exports.viewType = {}));
/**
 * @param {viewType} uploadType what to display, upload or list
 * @param {Array<string>} fileType the desired file formats to be uploaded
 * @param {stirng} sizeLimit the maximum size of value that should be uploaded
 * @param {Function} onUpload what to do when a file is uploaded (optional)
 * @param {Array<FileProps>} files files to be shown in list
 * @param {boolean} initValue the initial state of the upload prompt, pressed or
 * not pressed (optional)
 * @param {boolean} multiple whether or not multiple files should be uploaded
 * @param {string} className additional classes to add (optional)
 **/
var Files = function (props) {
    var uploadType = props.uploadType, fileType = props.fileType, sizeLimit = props.sizeLimit, onUpload = props.onUpload, files = props.files, initValue = props.initValue, multiple = props.multiple, className = props.className, dataTestID = props["data-testid"];
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: uploadType === viewType.Upload ? ((0, jsx_runtime_1.jsx)("div", __assign({ "data-testid": dataTestID, className: className ? className : '' }, { children: (0, jsx_runtime_1.jsx)(exports.FileUpload, { fileType: fileType, sizeLimit: sizeLimit, onUpload: onUpload, initValue: initValue, multiple: multiple }) }))) : ((0, jsx_runtime_1.jsx)("div", __assign({ "data-testid": dataTestID, className: className ? className : '' }, { children: (0, jsx_runtime_1.jsx)(exports.FileList, { files: files }) }))) }));
};
exports.Files = Files;
